import { format as fnsFormat } from "date-fns";

export function formatDate(date: string | Date, fmt = "MM/dd/yyyy"): string {
  if (!date) return "";
  const d = typeof date === "string" ? new Date(date) : date;
  return fnsFormat(d, fmt);
}

export function formatDateTime(date: string | Date): string {
  return formatDate(date, "EEEE MM/dd/yyyy @ h:mm a");
}

export function formatPhone(phone: string): string {
  const cleaned = String(phone).replace(/\D/g, "");
  const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match) return `(${match[1]}) ${match[2]}-${match[3]}`;
  return phone;
}

/** First letter of every word uppercase, rest lowercase (no all-caps). */
export function toTitleCase(s: string): string {
  if (!s || typeof s !== "string") return "";
  return s
    .toLowerCase()
    .split(/\s+/)
    .map((word) => (word ? word.charAt(0).toUpperCase() + word.slice(1) : ""))
    .join(" ");
}
